<template>
  <b-container
    fluid
    class="spinner-wrapper align-items-center justify-content-center"
  >
    <half-circle-spinner v-if="loaderId" />
  </b-container>
</template>

<script>
import { SIGN_OUT_ACTION } from '@/store';
import { saveToStorage } from '@/helpers/localStorageHelper';
import { HalfCircleSpinner } from 'epic-spinners';

export default {
  name: 'SignUpTokenHandler',
  components: {
    HalfCircleSpinner,
  },
  beforeMount: async function () {
    this.$wait.start(this.loaderId);
    try {
      if (this.$store.getters.isAuthenticated) {
        await this.$store.dispatch(SIGN_OUT_ACTION);
      }
      const { signUpToken } = this.$route.params;
      saveToStorage('sign-up-token', signUpToken);
    } catch (error) {
      process.env.NODE_ENV !== 'production' && console.error(error);
    } finally {
      this.$wait.end(this.loaderId);
      this.$router.push('/welcome-dashboard');
    }
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
  },
};
</script>

<style scoped>
.spinner-wrapper {
  display: flex;
  flex: 1 1;
}
</style>
